import React, { useEffect, useState } from 'react';
import { TOPIC } from '../../utility/constants/topicConstants';
import { subscribe } from '../../utility/utils/broadcast';
import styles from '../../styles/apiErrorNotification.module.scss';

export default function ApiErrorNotification() {
    const [notification, setNotification] = useState(null);

    useEffect(() => subscribe(TOPIC.API.GLOBAL_ERROR, (error) => {
        setNotification({
            id: Date.now(),
            message: error?.message || "We couldn't complete your request. Please try again.",
        });
    }), []);

    if (!notification) return null;

    return (
        <div className={styles.notification} role="alert" aria-live="assertive">
            <span>{notification.message}</span>
            <button
                type="button"
                className={styles.dismiss}
                onClick={() => setNotification(null)}
                aria-label="Dismiss error message"
            >
                ×
            </button>
        </div>
    );
}